import * as types from '../constants/actionTypes';

const initialState = {
  isReportPopupActive: false,
  isReportPostPopupActive: false,
  isReportPopupActiveV2: false,
  isReportPostPopupActiveV2: false,
};

const reportPopupReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_REPORT_POPUP:
      if (!action.data) {
        return {
          ...state,
          isReportPopupActiveV2: false,
          isReportPopupActive: false,
        };
      }
      if (action.v2) {
        return {
          ...state,
          isReportPopupActiveV2: action.data,
        };
      }
      return {
        ...state,
        isReportPopupActive: action.data,
      };
    case types.TOGGLE_REPORT_POPUP_POST:
      if (!action.data) {
        return {
          ...state,
          isReportPostPopupActiveV2: false,
          isReportPostPopupActive: false,
        };
      }
      if (action.v2) {
        return {
          ...state,
          isReportPostPopupActiveV2: action.data,
        };
      }
      return {
        ...state,
        isReportPostPopupActive: action.data,
      };
    default:
      return state;
  }
};

export default reportPopupReducer;
